import { createContext, useContext, useMemo } from "react";

// EUR-only pricing. Prices are stored and displayed as EUR throughout the app.
// The provider is kept as a thin compatibility layer so existing components
// (`useCurrency`, `useFormatMoney`) keep working without any changes.

const CurrencyContext = createContext({
  currency: "EUR",
  setCurrency: () => {},
  rateHuf: 0,
  format: (n) => (n == null || isNaN(n) ? "—" : `€${Number(n).toFixed(2)}`),
});

export function CurrencyProvider({ children }) {
  // Mirror onto globalThis so the bare `formatMoney(n)` helper in api.js
  // reads a consistent state (kept for backwards compatibility).
  if (typeof globalThis !== "undefined") {
    globalThis._b2bCurrency = { currency: "EUR", rateHuf: 0 };
  }

  const format = useMemo(
    () => (eur) => {
      if (eur == null || isNaN(eur)) return "—";
      return `€${Number(eur).toFixed(2)}`;
    },
    [],
  );

  const value = useMemo(
    () => ({ currency: "EUR", setCurrency: () => {}, rateHuf: 0, format }),
    [format],
  );

  return <CurrencyContext.Provider value={value}>{children}</CurrencyContext.Provider>;
}

export function useCurrency() {
  return useContext(CurrencyContext);
}

/** Returns a function `(eurAmount) => formatted` — always EUR. */
export function useFormatMoney() {
  return useCurrency().format;
}
